import React, { FC } from 'react';
import { Region } from '../../types/orderTypes';
import { useFetchRelabelList } from '../../hooks/useFetchRelabelList';
import 'browserprint/BrowserPrint-3.0.216.min.js';
import 'browserprint-zebra/BrowserPrint-Zebra-1.0.216.min.js';

import './relabelList.scss';
import { ButtonComponent } from '../../ReusableComponents/Button/ButtonComponent';
import { fetchLabelsAsZPL } from '../../fetch/fetchLabels';

export const RelabelList: FC<{ region: Region }> = ({ region }) => {
  const [bundlesForRelabelling, fetchStatus] = useFetchRelabelList(region);
  const [zones, setZones] = React.useState<string[]>([]);
  const bundlesWithInstaboxOrders = bundlesForRelabelling
    .filter(bundle => bundle.orderIdsToRelabel.length > 0)
    .sort((bundle1, bundle2) => bundle1.shelfId.localeCompare(bundle2.shelfId));

  React.useEffect(() => {
    const zones = bundlesForRelabelling
      .filter(bundle => bundle.orderIdsToRelabel.length > 0)
      .map(bundle => bundle.shelfId.charAt(0));
    setZones([...new Set(zones)]);
  }, [bundlesForRelabelling]);

  const [error, setError] = React.useState<string | null>(null);

  const fetchForZones = (zone: string) => {
    const bundlesToPrint = bundlesWithInstaboxOrders.filter(
      b => b.shelfId.indexOf(zone) !== -1
    );
    let orderIds = [];
    bundlesToPrint.forEach(
      bundle => (orderIds = orderIds.concat(bundle.orderIdsToRelabel))
    );
    return orderIds;
  };

  const fetchAndPrintLabels = (orderIds: string[]) => {
    fetchLabelsAsZPL(orderIds).then((blob: Blob) => {
      const BrowserPrint = (window as any).BrowserPrint;
      BrowserPrint.getDefaultDevice(
        'printer',
        device => {
          device.sendFile(
            blob,
            () => {
              setError(null);
            },
            () => {
              setError('Error printing labels');
            }
          );
        },
        () => {
          setError(
            'No printer installed, or browserprint not installed. Trying to print with default print functionality in the browser.'
          );
          const dataUrl = window.URL.createObjectURL(blob);
          const labelWindow = window.open(dataUrl);
          labelWindow.print();
        }
      );
    });
  };
  return (
    <div className="relabel-list">
      {error ? <span style={{ color: 'red' }}>{error}</span> : null}
      <div style={{ marginLeft: 20 }}>
        <h1>Print zones</h1>
        <div>
          {zones.map(zone => (
            <ButtonComponent
              style={{ marginTop: 10, marginLeft: 10 }}
              key={zone}
              onClick={() => fetchAndPrintLabels(fetchForZones(zone))}
            >
              ZONE - {zone}
            </ButtonComponent>
          ))}
        </div>
      </div>

      <div className="relabel-list__bundles">
        {bundlesWithInstaboxOrders.map(bundle => (
          <div key={bundle.bundleId} className="relabel-list__bundle">
            <div className="relabel-list__bundle__inner">
              <div className="relabel-list__bundle__shelf-id">
                {bundle.shelfId}
              </div>
              <div className="relabel-list__bundle__details">
                <span>{`Bundle: ${bundle.bundleId}`}</span>
                <span>{`${bundle.orderIdsToRelabel.length} orders to relabel`}</span>
              </div>
            </div>
            <ButtonComponent
              onClick={() => fetchAndPrintLabels(bundle.orderIdsToRelabel)}
            >
              Print Labels
            </ButtonComponent>
          </div>
        ))}
      </div>
    </div>
  );
};
